import React, { useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import { SketchPicker } from "react-color";
import SingleSelectBox from "../FormComponents/SingleSelectBox";
import Input from "../FormComponents/Input";
import Label from "../FormComponents/Label";
import { InlineColorMasterdataSelection } from "./EditField";
import MultiRadio from "../FormComponents/MultiRadio";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const EditProgressTracker = ({ editElementData, setEditElementData, tableID }) => {
  const [isTotalOpen, setIsTotalOpen] = useState(false);
  const [isCompletedOpen, setIsCompletedOpen] = useState(false);
  const [openColorPicker, setOpenColorPicker] = useState(false);

  const updateProgressFields = (key, data) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [key]: data
    }));
    setIsTotalOpen(false);
    setIsCompletedOpen(false);
  };

  const handleRadioChange = (key, data) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [key]: {
        value_type: data,
        // value: prevData[key]?.value || ""
        value: ""
      }
    }));
    setIsTotalOpen(false);
    setIsCompletedOpen(false);
  };
  const handleUpdateValues = (key, data) => {
    setEditElementData((prevData) => ({
      ...prevData,
      [key]: {
        value: data,
        value_type: prevData[key]?.value_type || ""
      }
    }));
    setIsTotalOpen(false);
    setIsCompletedOpen(false);
  };

  const handleColorPicker = (index) => {
    if (index === openColorPicker) {
      setOpenColorPicker("");
    } else {
      setOpenColorPicker(index);
    }
  };

  const progressTrackerTypeOptions = [
    { id: "linear", name: "linear" },
    { id: "circular", name: "circular" }
  ];

  const formatOptions = [
    { id: "percentage", name: "percentage" },
    { id: "count", name: "count" }
  ];

  const filterOptions = [
    { id: "mapped", name: "Mapped" },
    { id: "hardcoded", name: "Hardcoded" }
  ];
  return (
    <>
      <Input
        label="Title"
        value={editElementData?.title}
        onChange={(e) => updateProgressFields("title", e.target.value)}
      />
      <div className="flex_column gap_2 ">
        <Label className="builder_label">Total value</Label>
        <MultiRadio
          keyName="total_value"
          options={filterOptions}
          selectedValue={editElementData?.total_value?.value_type || ""}
          onChange={(e) => handleRadioChange("total_value", e.target.value)}
        />
        {editElementData?.total_value?.value_type === "hardcoded" ? (
          <Input
            value={editElementData?.total_value?.value}
            type="number"
            onChange={(e) => handleUpdateValues("total_value", e.target.value)}
          />
        ) : (
          <div className="builder_input d_flex justify_center cursor_pointer" onClick={() => setIsTotalOpen(true)}>
            {editElementData?.total_value?.value
              ? `${editElementData.total_value?.value?.prefix}.${editElementData.total_value?.value?.display}`
              : "No field assign"}
          </div>
        )}
      </div>

      <div className="flex_column gap_2 ">
        <Label className="builder_label">Completed value</Label>
        <MultiRadio
          keyName="completed_value"
          options={filterOptions}
          selectedValue={editElementData?.completed_value?.value_type || ""}
          onChange={(e) => handleRadioChange("completed_value", e.target.value)}
        />
        {editElementData?.completed_value?.value_type === "hardcoded" ? (
          <Input
            value={editElementData?.completed_value?.value}
            type="number"
            onChange={(e) => handleUpdateValues("completed_value", e.target.value)}
          />
        ) : (
          <div className="builder_input d_flex justify_center cursor_pointer" onClick={() => setIsCompletedOpen(true)}>
            {editElementData?.completed_value?.value
              ? `${editElementData.completed_value?.value?.prefix}.${editElementData.completed_value?.value?.display}`
              : "No field assign"}
          </div>
        )}
      </div>

      <Input
        type="number"
        label="Progress Tracker Width"
        name="width"
        value={editElementData?.width}
        onChange={(e) => updateProgressFields("width", e.target.value)}
      />

      <SingleSelectBox
        selectedData={editElementData.view_type}
        options={progressTrackerTypeOptions}
        onChange={(obj) => updateProgressFields("view_type", obj.id)}
        placeholder="select"
        label="Progress tracker type"
      />

      <SingleSelectBox
        selectedData={editElementData.format}
        options={formatOptions}
        onChange={(obj) => updateProgressFields("format", obj.id)}
        placeholder="select"
        label="Format"
      />

      <div className="flex_column gap_2 ">
        <Label className="builder_label">Color</Label>
        <div className="color_input_container w_100 d_flex">
          <Input
            placeholder="Color"
            value={editElementData.color}
            onChange={(e) => updateProgressFields("color", e.target.value)}
            inputBoxStyle={{ borderLeft: `8px solid ${editElementData.color}` }}
          />
          <MaterialIcon
            name={openColorPicker ? "close" : "colors"}
            className="color_icon"
            onClick={() => handleColorPicker(!openColorPicker)}
          />
          {openColorPicker && (
            <div className="color_picker_container">
              <SketchPicker
                color={editElementData.color || "#FFFFFF"}
                onChange={(e) => updateProgressFields("color", e.hex.toUpperCase())}
              />
            </div>
          )}
        </div>
      </div>

      <InlineColorMasterdataSelection
        colorConfigType={editElementData?.color_config_type}
        handleEditElementData={updateProgressFields}
        colorMasterData={editElementData?.color_master_data || ""}
        colorIf={editElementData?.colorif}
      />

      <BuilderModal isOpen={isTotalOpen} onClose={() => setIsTotalOpen(false)} modalName="Select field">
        <TableTreeModal
          callbackFunction={(data) => handleUpdateValues("total_value", data)}
          tableId={tableID}
          selectedFile={editElementData && editElementData?.total_value && editElementData?.total_value?.value?.id}
        />
      </BuilderModal>

      <BuilderModal isOpen={isCompletedOpen} onClose={() => setIsCompletedOpen(false)} modalName="Select field">
        <TableTreeModal
          callbackFunction={(data) => handleUpdateValues("completed_value", data)}
          tableId={tableID}
          selectedFile={
            editElementData && editElementData?.completed_value && editElementData?.completed_value?.value?.id
          }
        />
      </BuilderModal>
    </>
  );
};

export default EditProgressTracker;
